// import { CheckpointResult } from 'app/main/checkpoint/checkpoint-detail/CheckpointHelper';
// import { SkillCheckpointType } from '../app/admin/skill/SkillHelpers';
// import { AnswerQuestionStatus } from 'helpers/AnswerQuestionStatus';
// import {
//   ClassroomModel,
//   ClassroomStudent,
//   Teacher,
// } from './classroom/classroomModel';

export interface SkillModel {
  id: string;
  shareId?: string;
  name: string;
  pathName?: string; // CA add
  level?: number;
  documentId: string;
  spreadsheetId: string;
  descriptionDocumentId: string;
  numericalOrder: number;
  status: number;
  type: SkillType;
  skillChildType?: SkillType;
  gradeId: string;
  author: any;
  subjectId: string;
  category: CategoryModel;
  assignees: any[];
  skillResults: any[];
  skillScreenshots: any[];
  answeredQuestions: any[];
  templateQuestions: any[];
  skillSuggestions: any[];
  skillCheckpointCache: any;
  checkpoint: {
    checkpointHeaders: any;
    id: string;
    testTime: number;
    totalQuestion: number;
    // type: SkillCheckpointType;
    // checkpointResults: CheckpointResult[];
  };
  teacherCheckpointCache: any;
  user: any;
  functionTypes: any[][];
  showGame: boolean;
  linkGame: string;
}

export enum SkillType {
  RandomTemplateRandomLevel,
  SequenceTemplateRandomLevel,
  Checkpoint,
  Essay,
  Stage,
  RandomTemplateSequenceLevel,
  SkillGroup,
  SkillDataQuestionGroup,
  CheckpointCache,
  TheoryLesson,
  SkillCombine,
}

export enum SkillSuggestionLock {
  UnLock,
  Lock,
}

export interface CategoryModel {
  id: string;
  name: string;
  numericalOrder: number;
  gradeId: string;
  subjectId: string;
  parentId: string;
  children: any[];
  skills: SkillModel[];
}

export interface Suggestion {
  suggestionId: string;
  studentId: string;
  deadline?: any;
  skillExamSuggestion: SkillExamSuggestion;
}

export interface CheckpointSuggestionEntityModel {
  id: string;
  studentId: string;
  lock: SkillSuggestionLock;
  skill: SkillModel;
  checkpointSuggestion: {
    startTime: string;
    endTime: string;
  };
  skillExamSuggestion: SkillExamSuggestion;
  lessonId?: string;
}

export interface SkillExamSuggestion {
  startTime: any;
  endTime: any;
  showResultTime: any;
  numberQuestion: number;
  limitTime: number;
  totalQuestion: number;
  practiceTimes: number;
  practicedTimes: number;
  showAnswer: boolean;
  showScore: boolean;
  isDoing?: number;
}

export interface CheckpointSuggestionEntity {
  id: string;
  studentId: string;
  deadline?: any;
  checkpointSuggestion?: {
    startTime: any;
    endTime: any;
  };
}

export interface SkillSuggestionModel {
  classroomId: string;
  totalQuestion: number;
  suggestions: Suggestion[];
}

export interface CheckpointSuggestionModel {
  classroomId: string;
  suggestions: CheckpointSuggestionEntity[];
}

export interface LessonSkillSuggestionObj {
  skillId: string;
  suggestions: Suggestion[];
}

export interface LessonSuggestionModel {
  classroomId: string;
  skills: LessonSkillSuggestionObj[];
}

export interface StudentSuggestionModel {
  id: string;
  studentId: string;
  classroomId: string;
  teacherId: string;
  skillId: string;
  skill: SkillModel;
  // student: ClassroomStudent;
  // teacher: Teacher;
  // classroom: ClassroomModel;
  status: any;
  deadline?: any;
  completionTime?: Date;
  createdDate?: Date;
  lesson?: LessonModel;
  lessonId?: string;
  lock: SkillSuggestionLock;
}

export interface AnswerResponseModel {
  correctAnswer: any[];
  totalAnswerCorrect: number;
  totalQuestion: number;
}

export interface LessonModel {
  name: string;
}

export interface SkillStageResultDto {
  currentStage: number;
  currentIndexQuestionInStage: number;
  totalQuestionInStage: number;
  minNumberQuestionNeedCorrect: number;
  // statusAnswerdQuestions: AnswerQuestionStatus[];
  stageStatus: StageStatus;
  totalStage: number;
}

export enum StageStatus {
  StartStage,
  DoingStage,
  EndStageSuccess,
  EndStageFail,
  FinishSkill,
}

export enum ShowKey {
  showKeyOne,
  showKeyAll,
  notShowKey,
  checkAnswer,
}

export enum StatusSaveEssay {
  notSave,
  saving,
  saved,
}

export enum GetSkillQuestionType {
  None,
  Previous,
  Next,
}

export enum StatusAnswer {
  notCheck = 'not-check',
  correct = 'correct',
  incorrect = 'incorrect',
}

export enum ViewMode {
  FullScreen, // 16:9
  Normal, // 4:3
}

export enum ToolsScreenMode {
  HideScreen,
  ShowScreen,
  Spotlight,
  NotCheck,
  HideFullScreen,
}
